const styles = () => ({
  headerGrid: {
    paddingTop: '32px !important',
  },
  grid: {
    paddingTop: '24px !important',
  },
})

export default styles
